<template>
  <div class="container">
    <BaseFrame @setAble='setAble' :infos='infos' :idText='idText' :able='able' @save='submit("StoreForm")'
               @clear='clear'  saveText='保存' :saveLoading="saveLoading"
               @hanldeLog="getModifiedRecord"
               :logData='LogItems'
               :logText="storeId? '操作日志' : ''"
               >
      <div slot="content">
        <lk-form :model="StoreForm.sysStore" label-position="right" :label-width="130" :rules="ruleValidate"
                 ref="StoreForm">
          <div class="cardContainer">
            <lk-card title="基本信息">
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="门店名称:" prop="name">
                    <lk-input :maxlength='20' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.name"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="门店简称:" prop="shortName">
                    <lk-input :maxlength='10' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.shortName"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="企业负责人（备案）:">
                    <lk-select
                      clearable v-model.trim="StoreForm.sysStore.leader" :disabled="isAdd"
                      not-found-text="未找到对应账户，请先创建账户">
                      <lk-option v-for="item in leaders" :key="item.id" :value="item.id">
                        {{item.name}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
                </lk-row>
              <lk-row  :gutter='16'>
                <lk-col span="7" >
                  <lk-form-item label="电话:" prop='phone'>
                    <lk-input :maxlength='50' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.phone">
                    </lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="门店面积:" prop='area'>
                    <lk-input :maxlength='7' placeholder='请输入' number v-model.trim="StoreForm.sysStore.area">
                      <span slot="append">平方米</span>
                    </lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="门店地址:" prop="locationArr">
                    <location v-model="StoreForm.sysStore.locationArr"></location>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row  :gutter='16'>
                <lk-col span="7" >
                  <lk-form-item label="详细地址:">
                    <lk-input :maxlength='50' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.address"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="附近医院/输注中心:">
                    <lk-input :maxlength='100' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.hospitalAddress"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="经营方式:">
                    <lk-select clearable v-model.trim="StoreForm.sysStore.bizMode">
                      <lk-option v-for="(item,index) in bizMode.slice(1)" :value="index+1" :key="index">{{item}}</lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="经度:" prop="longitude">
                    <lk-input :maxlength='12' placeholder='请输入' :number="true" clearable v-model.trim="StoreForm.sysStore.longitude"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="纬度:" prop="latitude">
                    <lk-input :maxlength='12' placeholder='请输入' :number="true" clearable v-model.trim="StoreForm.sysStore.latitude"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="营业开始时间:" prop='businessStartTime'>
                    <lk-time-picker
                      type="time"
                      :editable="false"
                      v-model="StoreForm.sysStore.businessStartTime"
                      placement="bottom-end"
                      placeholder="请选择"
                      style="width: 168px">
                    </lk-time-picker>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="营业结束时间:" prop='businessEndTime'>
                    <lk-time-picker
                      type="time"
                      :editable="false"
                      v-model="StoreForm.sysStore.businessEndTime"
                      placement="bottom-end"
                      placeholder="请选择"
                      style="width: 168px">
                    </lk-time-picker>
                  </lk-form-item>
                </lk-col>
              </lk-row>
              <lk-row :gutter='16'>
                <lk-col span="7">
                  <lk-form-item label="门店级别:">
                    <lk-select clearable v-model.trim="StoreForm.sysStore.level" @on-change="fetchBizScope">
                      <lk-option v-for="(item,index) in levels" :value="index+1" :key="index+1">
                        {{item}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1'>
                  <lk-form-item label="药店类型:" >
                    <lk-select clearable v-model.trim="StoreForm.sysStore.type">
                      <lk-option v-for="(item,index) in storeTypes" :value="index+1" :key="index+1">
                        {{item}}
                      </lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset="1">
                  <lk-form-item label="是否医保店:" class="inline">
                    <lk-radio-group v-model.trim="StoreForm.sysStore.isMedicare">
                      <lk-radio :label="1">是</lk-radio>
                      <lk-radio :label="2">否</lk-radio>
                    </lk-radio-group>
                  </lk-form-item>
                  <lk-form-item label="医保备注:" v-if="StoreForm.sysStore.isMedicare === 1">
                    <lk-input :maxlength='50' placeholder='对接多个医保,请将医保名称用;分开' clearable v-model.trim="StoreForm.sysStore.medicareRemark"></lk-input>
                  </lk-form-item>
                </lk-col>


                <lk-col span="23">
                  <lk-form-item label="经营范围:" class="mt8 treeFormat" prop='goodsLabelIds'>
                    <lk-select v-model="StoreForm.bizScopeIdList" multiple filterable>
                      <lk-option v-for="item in bizScopeList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
                    </lk-select>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
          <div class="cardContainer">
            <lk-card title="资质信息">
              <lk-row :gutter="16">
                <lk-col span="7" class="backGroundCard">
                  <lk-form-item prop='bizLicenseUrl' >
                    <div class="label required withPic">
                      <label>营业执照:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.bizLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="统一社会信用代码:" prop='bizLicenseCode'>
                    <lk-input :maxlength='18' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.bizLicenseCode" @on-change="creditCodeModel"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='bizLicenseExpiry'>
                    <expirePicker :hasForever="true" :able='true' :type='1' :options='disableFromNow' v-model.trim="StoreForm.sysStore.bizLicenseExpiry" :isForever='StoreForm.sysStore.bizLicenceForever' @handleForever='handleForever($event)'></expirePicker>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item prop='goodsLicenseUrl' class="mt8">
                    <div class="label withPic">
                      <label>药品经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.goodsLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='goodsLicenseCode'>
                    <lk-input :maxlength='30' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.goodsLicenseCode"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='goodsLicenseExpiry'>
                    <expirePicker :able='true' :type='1' :options='disableFromNow' v-model.trim="StoreForm.sysStore.goodsLicenseExpiry"></expirePicker>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" class="backGroundCard" offset='1'>
                  <lk-form-item prop='gspUrl' class="mt8">
                    <div class="label withPic">
                      <label>GSP规范认证证书:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.gspUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='gspCode'>
                    <lk-input :maxlength='30' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.gspCode"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='gspExpiry'>
                    <expirePicker :able='true' :type='1' :options='disableFromNow' v-model.trim="StoreForm.sysStore.gspExpiry"></expirePicker>
                  </lk-form-item>
                </lk-col>
                 </lk-row>
                <lk-row :gutter="16">
                <lk-col span="7" class="backGroundCard">
                  <lk-form-item prop='foodLicenseUrl' class="mt8">
                    <div class="label withPic">
                      <label>食品经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.foodLicenseUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='foodLicenseCode'>
                    <lk-input :maxlength='20' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.foodLicenseCode"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='foodLicenseExpiry'>
                    <expirePicker :able='true' :type='1' :options='disableFromNow' v-model.trim="StoreForm.sysStore.foodLicenseExpiry"></expirePicker>
                  </lk-form-item>
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item prop='thirdMedicalUrl' class="mt8">
                    <div class="label withPic">
                      <label>第三类医疗器械经营许可证:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.thirdMedicalUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='thirdMedicalCode'>
                    <lk-input :maxlength='30' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.thirdMedicalCode"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="有效日期:" prop='thirdMedicalExpiry'>
                    <expirePicker :able='true' :type='1' :options='disableFromNow' v-model.trim="StoreForm.sysStore.thirdMedicalExpiry"></expirePicker>
                    <!-- <lk-DatePicker  placeholder=" 请选择" :options='disableFromNow'  style="width:100%" v-model.trim="StoreForm.sysStore.thirdMedicalExpiry"></lk-DatePicker>
                    <expire-info
                      :day="180"
                      :dateTime="StoreForm.sysStore.thirdMedicalExpiry"
                    >
                    </expire-info> -->
                  </lk-form-item>
                  <!-- <lk-form-item label="社会统一信用码:">
                    <lk-input :maxlength='100' placeholder='请输入'  v-model.trim="StoreForm.sysStore.creditCode" disabled>
                    </lk-input>
                  </lk-form-item> -->
                </lk-col>
                <lk-col span="7" offset='1' class="backGroundCard">
                  <lk-form-item class="mt8">
                    <div class="label withPic">
                      <label>二类医疗器械经营备案:</label>
                    </div>
                    <Uploader :able='able' v-model="StoreForm.sysStore.secondMedicalUrl"></Uploader>
                  </lk-form-item>
                  <lk-form-item label="证件号:" prop='secondMedicalCode'>
                    <lk-input :maxlength='30' placeholder='请输入' clearable v-model.trim="StoreForm.sysStore.secondMedicalCode"></lk-input>
                  </lk-form-item>
                  <lk-form-item label="备案日期:" prop='secondMedicalDate'>
                    <timeStampDatePicker  placeholder=" 请选择"   style="width:100%" v-model.trim="StoreForm.sysStore.secondMedicalDate"></timeStampDatePicker>
                  </lk-form-item>
                </lk-col>
              </lk-row>
            </lk-card>
          </div>
        </lk-form>
      </div>
    </BaseFrame>
    <DTPModal v-model="showClear" @confirm='onReset' content='重置将取消当前所做更改。' type='alert'></DTPModal>
  </div>
</template>
<script>
import BaseFrame from '@/components/frame/BaseFrame.vue';
import Uploader from '@/components/Uploader.vue';
import location from '@/components/location.vue';
import system from '@/services/system';
import DTPModal from '@/components/DTPModal.vue';
import utils from '@/libs/utils';
import mapState from '@/mixins/mapState';
import timeStampDatePicker from '../../components/timeStampDatePicker.vue';
import goods from '../../services/goods';
import expirePicker from '../../components/expireInfo/expirePicker.vue';


export default {
  name: 'StoreEdit',
  mixins: [mapState],
  components: {
    BaseFrame,
    Uploader,
    location,
    DTPModal,
    timeStampDatePicker,
    expirePicker,
  },
  data() {
    const nameValidate = (rule, value, callback) => { // 门店名称远程验证重复
      this.$store.commit('setDisableLoading', true);
      system.storeNameCheck({
        name: value,
        id: this.storeId,
      }).then((res) => {
        if (res.data.status === 200) {
          callback();
        } else {
          callback(new Error(res.data.error));
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    };
    const storeAreaTest = (rule, value, callback) => {
      if (value > 0) {
        const temp = `${value}`;
        if ((temp.includes('.') && temp.split('.')[1].length <= 2)) {
          this.StoreForm.sysStore.area = value * 1;
          callback();
        } else if (temp.includes('.')) {
          callback(new Error('门店面积精度为小数点后两位'));
        }
        this.StoreForm.sysStore.area = value * 1;
        callback();
      } else {
        callback(new Error('门店面积为大于0的数字'));
      }
    };
    const longitudeVal = (rule, value, callback) => {
      if (value >= -180 && value <= 180) {
        let tempValue = `${value}`;
        if (tempValue.indexOf('.') !== -1) {
          let temp = tempValue.split('.');
          if (temp[1] && temp[1].length && temp[1].length <= 6) {
            callback();
          } else {
            callback(new Error('小数最多有6位'));
          }
        } else {
          callback();
        }
      } else {
        callback(new Error('请输入-180 - 180的字符'));
      }
    }
    const latitudeVal = (rule, value, callback) => {
      if (value >= -90 && value <= 90) {
        let tempValue = `${value}`;
        if (tempValue.indexOf('.') !== -1) {
          let temp = tempValue.split('.');
          if (temp[1] && temp[1].length && temp[1].length <= 6) {
            callback();
          } else {
            callback(new Error('小数最多有6位'));
          }
        } else {
          callback();
        }
      } else {
        callback(new Error('请输入-90 - 90的字符'));
      }
    }
    return {
      storeId: '',
      saveLoading: false,
      bizScopeList: [],
      isAdd: true,
      modifiedRecords: [],
      disableFromNow: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now();
        },
      },
      idText: '',
      showClear: false,
      judge: ['', '是', '否'],
      bizMode: ['', '零售', '生产', '批发'],
      able: false,
      infos: null,
      leaders: [],
      managers: [],
      bizScope: [],
      levels: ['一级', '二级', '三级'],
      storeTypes: ['直营', '收购', '加盟'],
      StoreForm: {
        sysStore: {
          businessStartTime: null,
          businessEndTime: null,
          latitude: '',
          longitude: '',
          address: '',
          bizLicenseUrl: '',
          bizLicenseCode: '',
          bizLicenseExpiry: null,
          cityId: null,
          cityName: '',
          countyId: null,
          countyName: '',
          locationArr: [],
          creditCode: '',
          code: '',
          goodsLicenseUrl: '',
          goodsLicenseCode: '',
          goodsLicenseExpiry: null,
          foodLicenseUrl: '',
          foodLicenseCode: '',
          foodLicenseExpiry: null,
          gspUrl: '',
          gspCode: '',
          gspExpiry: null,
          id: '',
          hospitalAddress: '',
          isMedicare: '',
          medicareRemark: '',
          leader: null,
          leaderName: '',
          manager: '',
          managerName: '',
          name: '',
          shortName: '',
          bizMode: null,
          bizScopeIds: '',
          level: null,
          type: '',
          provinceId: null,
          provinceName: '',
          secondMedicalUrl: '',
          secondMedicalCode: '',
          status: null,
          phone: '',
          area: '',
          thirdMedicalUrl: '',
          thirdMedicalCode: '',
          thirdMedicalExpiry: null,
        },
      },
      ruleValidate: {
        businessStartTime: [
          { required: true, message: '请选择营业开始时间', trigger: 'blur'}
        ],
        businessEndTime: [
          { required: true, message: '请选择营业结束时间', trigger: 'blur'}
        ],
        longitude: [
          { required: true, message: '请输入经度', trigger: 'blur', type: 'number'},
          { validator: longitudeVal, trigger: 'blur'}
        ],
        latitude: [
          { required: true, message: '请输入纬度', trigger: 'blur', type: 'number'},
          { validator: latitudeVal, trigger: 'blur'}
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { validator: nameValidate, trigger: 'blur' },
        ],
        shortName: [
          { required: true, message: '请输入简称', trigger: 'blur' },
        ],
        manager: [{
          required: true, message: '请选择门店管理员', trigger: 'change', type: 'number',
        }],
        locationArr: [{
          required: true, message: '请选择门店地址', trigger: 'change', type: 'array',
        }],
        area: [
          {
            required: true, message: '请输入门店面积', trigger: 'blur', type: 'number',
          },
          { validator: storeAreaTest, params: { min: 0 }, trigger: 'blur' },
        ],
        phone: [{
          validator: utils.validate.phoneValidator, message: '请输入正确电话号码', trigger: 'blur',
        }],
        bizLicenseCode: [{
          required: true, message: '请输入统一社会信用代码', trigger: 'blur',
        }],
      },
      LogItems: [],
    };
  },
  methods: {
    getModifiedRecord() {
      system.getStoreHistory({ id: this.storeId }).then((res) => {
        if (res.data.status === 200) {
          this.LogItems = utils.deepClone(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleInputRegister() {
      this.$nextTick(() => {
        const allInput = document.querySelectorAll('.ivu-card-body .ivu-input:not(.ivu-input-disabled)');
        allInput.forEach((item, index) => {
          item.onkeydown = (e) => {
            if (e.key === 'Enter') {
              let nextIndex = index + 1;
              if (nextIndex >= allInput.length) {
                nextIndex = 0;
              }
              const nextEl = allInput[nextIndex];
              nextEl.focus();
            }
          };
        });
      });
    },
    submit(name) { // 验证函数
      this.$refs[name].validate((valid) => {
        if (valid) {
          const saveFunc = this.isAdd ? system.storeSave : system.storeUpdate;
          if (this.StoreForm.sysStore.locationArr.length) {
            const [provinceId, cityId, countyId] = this.StoreForm.sysStore.locationArr;
            this.StoreForm.sysStore.provinceId = provinceId || '';
            this.StoreForm.sysStore.cityId = cityId || '';
            this.StoreForm.sysStore.countyId = countyId || '';
          }
          const data = utils.deepClone(this.StoreForm);
          for (const key in data.sysStore) {
            if (key.includes('Exprie')) {
              if (data.sysStore[key]) {
                data.sysStore[key] = (new Date(data.sysStore[key])).getTime();
              }
            }
            if (key.includes('Time') && !key.includes('business')) {
              if (data.sysStore[key]) {
                data.sysStore[key] = (new Date(data.sysStore[key])).getTime();
              }
            }
            // data.sysStore.secondMedicalDate = (new Date(data.sysStore[key])).getTime();
          }
          data.sysStore.area = Math.round(data.sysStore.area * 100);
          this.saveLoading = true;
          saveFunc(data).then((res) => {
            if (res.data.status === 200) {
              this.$store.commit('setStoreList', []);
              this.$Message.success('保存成功');
              this.$nextTick(() => {
                this.$router.push({ name: 'storeList', params: { create: this.isAdd } });
              });
            } else {
              this.$Message.error(res.data.error);
            }
            this.saveLoading = false;
          }).catch((err) => {
            utils.handleError(err);
            this.saveLoading = false;
          });
        } else {
          this.$Message.error('请填写完整信息');
        }
      });
    },
    handleForever(val) {
      this.StoreForm.sysStore.bizLicenceForever = val;
      if (val) {
        this.StoreForm.sysStore.bizLicenseExpiry = null;
      }
    },
    setAble(val) { // frame判定框架是否支持录入
      this.able = val;
      if (!this.able) {
        this.$set(this.ruleValidate, null);
      }
    },
    onReset() {
      this.initData();
      this.showClear = false;
    },
    clear() {
      this.showClear = true;
    },
    getDropList(types) {
      return system.dropList(types);
    },
    getLeadersAndManagersAndScope() {
      return new Promise(((resolve, reject) => {
        this.getDropList({
          dropListTypes: 'leader_list',
          storeId: this.storeId,
        }).then((res) => {
          if (res.data.status == 200) {
            const data = res.data.data;
            this.leaders = data.leaderList;
            resolve(true);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          reject(err);
        });
      }));
    },
    // getManagers() {
    //   this.getDropList({ dropListTypes: 'manager_list' }).then((res) => {
    //     if (res.data.status == 200 && res.data.data.managerList) {
    //       this.managers = res.data.data.managerList;
    //     }
    //   });
    // },
    getInfo(id) {
      system.storeInfo({ id }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          const modifiedRecord = {};
          const locationArr = [];
          this.idText = '门店ID';
          if (temp.sysStore.bizLicenceForever) {
            temp.sysStore.bizLicenseExpiry = null;
          }
          modifiedRecord.id = temp.sysStore.id;
          modifiedRecord.createUserName = temp.sysStore.createUserName;
          modifiedRecord.createTime = utils.formatTime(temp.sysStore.createTime);
          modifiedRecord.modifiedUserName = temp.sysStore.modifiedUserName;
          modifiedRecord.modifiedTime = utils.formatTime(temp.sysStore.modifiedTime);
          this.infos = modifiedRecord;
          // for (const key in temp.sysStore) {
          //   if (key.includes('Expiry')) {
          //     temp.sysStore[key] = utils.exchangeTime(temp.sysStore[key]);
          //   }
          // }
          temp.sysStore.area = temp.sysStore.area ? utils.exchangePercent(temp.sysStore.area) : '';
          this.StoreForm = Object.assign({}, temp);
          // this.bizScopeTree = this.generateTree();
          if (this.StoreForm.sysStore.provinceId) {
            locationArr.push(this.StoreForm.sysStore.provinceId);
            if (this.StoreForm.sysStore.cityId) {
              locationArr.push(this.StoreForm.sysStore.cityId);
              if (this.StoreForm.sysStore.countyId) {
                locationArr.push(this.StoreForm.sysStore.countyId);
              }
            }
          }
          this.StoreForm.sysStore.locationArr = locationArr;
          this.handleInputRegister();
        } else {
          this.$Message.error(res.data.error);
        }
        this.fetchBizScope();
      });
    },
    fetchBizScope() {
      const storeLevelId = this.StoreForm.sysStore.level;
      if (storeLevelId) {
        this.$store.commit('setDisableLoading', true);
        goods.listGoodsLabels({ storeLevelId, categoryId: 2, status: 1 }).then((res) => {
          if (res.data.status === 200) {
            const { list } = res.data.data;
            this.bizScopeList = list;
            // this.bizScopeTree = this.generateTree();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      } else {
        // this.bizScopeTree = [];
        this.StoreForm.bizScopeIdList = [];
      }
    },
    creditCodeModel() {
      this.StoreForm.sysStore.creditCode = this.StoreForm.sysStore.bizLicenseCode;
    },
    initData() {
      if (this.isAdd) {
        // this.getManagers();
        this.StoreForm = {
          sysStore: {
            bizLicenceForever: false,
            businessStartTime: null,
            businessEndTime: null,
            longitude: '',
            address: '',
            bizLicenseUrl: '',
            bizLicenseCode: '',
            bizLicenseExpiry: null,
            cityId: null,
            cityName: '',
            countyId: null,
            countyName: '',
            locationArr: [],
            creditCode: '',
            code: '',
            goodsLicenseUrl: '',
            goodsLicenseCode: '',
            goodsLicenseExpiry: null,
            foodLicenseUrl: '',
            foodLicenseCode: '',
            foodLicenseExpiry: null,
            gspUrl: '',
            gspCode: '',
            gspExpiry: null,
            id: '',
            hospitalAddress: '',
            isMedicare: '',
            medicareRemark: '',
            leader: null,
            leaderName: '',
            manager: '',
            managerName: '',
            name: '',
            shortName: '',
            bizMode: null,
            bizScopeIds: '',
            level: 3,
            type: '',
            provinceId: null,
            provinceName: '',
            secondMedicalUrl: '',
            secondMedicalCode: '',
            status: null,
            phone: '',
            area: '',
            thirdMedicalUrl: '',
            thirdMedicalCode: '',
            thirdMedicalExpiry: null,
          },
        };
        this.fetchBizScope();
      } else {
        // this.getManagers();
        this.getLeadersAndManagersAndScope()
          .then((res) => {
            console.log(res);

            this.getInfo(this.storeId);
          });
      }
    },
  },
  mounted() {
    this.storeId = this.$route.params.id;
    if (this.$route.name !== 'storeAdd') {
      this.isAdd = false;
    }
    this.initData();
    this.handleInputRegister();
  },
};
</script>
<style lang="less" scoped>
  .cardContainer {
    margin-bottom: 16px;
  }
  .p-font{
    padding: 0 10px;
    margin-bottom: 10px;
  }
  .backGroundCard{
    background: linear-gradient(180deg, #f5f5f5 0, #f5f5f5 calc(~'100% - 8px'),#fff calc(~'100% - 7px'));
    padding-top: 4px;
    padding-bottom: 4px;
  }
</style>
